// extracted by mini-css-extract-plugin
module.exports = {"no-more-items":"Activities_no-more-items__mB4po"};